<div class="modal-overlay" *ngIf="isOpen">
  <div class="modal-container">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ 'pages.productConfig.modal.confirmation.title' | i18n }}</h2>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <p class="modal-description" [innerHTML]="'pages.productConfig.modal.confirmation.messageWithLink' | i18n: { domain: domain }"></p>
      <p class="modal-description">{{ 'pages.productConfig.modal.confirmation.note' | i18n }}</p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-confirm" (click)="onConfirm()">
        {{ 'pages.productConfig.modal.confirmation.confirmButton' | i18n }}
      </button>
    </div>
  </div>
</div>